import * as _ from 'lodash'

/**
 * Util provides returns an Array of pages objects which contains the pages key and value from the pages object.
 * @param previewsIndex
 * @param lpp
 * @returns []
 */
let resolvePagesArray = (previewsIndex, lpp) => {
  let pages = Object.values(lpp.pages)
  let pageId = Object.keys(lpp.pages)
  let sortedContentIds = _.sortBy(previewsIndex, o => o.index).map((x) => x.contentId)

  let pagesArray = pages.map((x, i) => {
    return {
      contentId: pageId[i],
      pageContent: x
    }
  })
  return _.sortBy(pagesArray, item => sortedContentIds.indexOf(item.contentId))
}

export default {
  resolvePagesArray
}
